import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/core/api/client';

/**
 * Hook for creating Calendly engagement
 * Feature 035: Calendly Consultation Scheduling
 */

type CreateCalendlyEngagementRequest = {
  providerId: string;
  careSeekerId: string;
  calendlyEventUrl?: string;
  scheduledAt?: string;
  profileViewEngagementId?: string;
};

type CreateCalendlyEngagementResponse = {
  id: string;
  providerId: string;
  careSeekerId: string;
  status: string;
  createdAt: string;
};

async function createCalendlyEngagement(
  data: CreateCalendlyEngagementRequest,
): Promise<CreateCalendlyEngagementResponse> {
  const response = await apiClient.post<CreateCalendlyEngagementResponse>(
    '/consultations/calendly',
    data,
  );

  return response.data;
}

export function useCreateCalendlyEngagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCalendlyEngagement,
    onSuccess: () => {
      // Invalidate consultation queries to refresh engagement lists
      queryClient.invalidateQueries({ queryKey: ['consultations'] });
      queryClient.invalidateQueries({ queryKey: ['engagements'] });
    },
  });
}
